module.exports = __webpack_public_path__ + "static/media/leandro-v-soc.f499a69c.png";